/* 🤖 this file was generated by svg-to-ts */
export const matIconSegment: {
  name: 'segment';
  data: string;
} = {
  name: 'segment',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M9 18h12v-2H9v2zM3 6v2h18V6H3zm6 7h12v-2H9v2z"/></svg>`
};
